import { Component, OnInit, ViewChild, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main-service.service';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
// import { plaidService } from 'src/app/services/plaid.service';
// import { Socket } from 'ngx-socket-io';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { Socket } from 'socket.io-client';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
  onlyCloseButton: boolean;
  proposalSub: Subscription;
  enrollmentFee: any;
  contract_service_record: any;
  @Output() triggerChangeScreen = new EventEmitter();
  @Output() triggerChangeScreens = new EventEmitter();
  manual_continue = false;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public mainService: MainService,
    public proposal: ProposalService,
    // public plaidService: plaidService,
    public socket: Socket,
    public _toaster: ToasterService, private modalService: BsModalService) { }
  contractToken: any;
  url: string = '';
  planInfo: any = {};
  previousRoute: any;
  refresh_token = 0;
  modalRef: BsModalRef;
  step = 1;
  reasonSent = false;
  reasonList = [];
  /* Send Feedback - Reason */
  reasonCheckedList = [];
  otherReason: string;
  reasonError = false;
  noChildSelected = true;
  @ViewChild('cancelModal') public cancelModal: ModalDirective;
  @Input() closeOnly;
  @Input() api;
  @Input() profileButtons;
  @Input() buttonWhite;
  apiCalledFromToken = false;
  showSSNFields = true;
  headerExpendicon: boolean = false;
  topHeaderexpend: boolean = false;
  getPaymentUrl = false;
  redirect_url = '';
  ngOnInit() {
    localStorage.removeItem('split_req_id');
    localStorage.removeItem('contract_id');
    this.route.queryParams.subscribe((resp: any) => {
      if (resp && resp.manual_continue) {
        this.manual_continue = JSON.parse(resp.manual_continue);
      }
      if (resp && resp.redirect_url && resp.redirect_url.length) {
        this.redirect_url = resp.redirect_url;
      }
    });

    if ((this.route.snapshot.url[0].path !== 'plans')) {
      this.getPaymentUrl = true;
      // console.log(this.getPaymentUrl, 'pay-url');

    }

    this.onlyCloseButton = this.closeOnly;
    this.socket.on('connect', () => {
      // console.log('Socket connected');
    });
    this.socket.on('PING', () => {
      this.socket.emit('ping_back', {
        contract_token: this.contractToken,
        url: this.router.url
      });
    });
    this.socket.on('disconnect', () => {
      // console.log('Socket disconnected');
    });
    this.route.params.subscribe((data: any) => {
      this.contractToken = data.token;
      if (!this.apiCalledFromToken) {
        this.checkIfArPp();
        this.apiCalledFromToken = true;
      }
      if (this.socket) {
        this.socket.emit('auth', {
          contract_token: this.contractToken,
          url: this.router.url
        });
      }
    });
    this.route.queryParams.subscribe((data: any) => {
      if (data && data.refresh && this.refresh_token != data.refresh) {
        this.checkIfArPp();
      }
    });
    if (this.onlyCloseButton) {
      this.proposalSub = this.proposal.getData().subscribe(data => {
        if (data && !Number(data.is_error)) {
          this.planInfo = data.split_request_data[0];
        }
      });
    }

    // this.plaidService.plaid_success_subject.subscribe((error: any) => {
    //   this.checkIfArPp();
    // });
    this.url = this.route.snapshot.url.toString().split(',')[0];
    this.previousRoute = this.mainService.getPreviousUrl();
    this.mainService.closeModalSteps.subscribe(data => {
      if (data) {
        this.mainService.closeModalSteps.next(false);
        this.router.navigate(['/remind-later/' + this.contractToken], { queryParams: { reason: 'Remind me later' } });
      }
    });
  }


  redirectBack() {
    window.location.href = this.redirect_url;
  }

  checkToken() {
    if (this.closeOnly && !this.api) {
      return;
    }

    let params = {
      contract_token: this.contractToken,
      timezone: this.mainService.getCurrentTimezone()
    };
    this.mainService.setLoader(true);
    this.proposal
      .api("post", "check_email_code_apf", this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data && data.doctor_country_currency_info && data.doctor_country_currency_info.country) {
          this.mainService.dollarSign$.next(data.doctor_country_currency_info);
        }
        if (data && data.validation_rules) {
          this.mainService.regex$.next(data.validation_rules);
        }
        // tslint:disable-next-line:max-line-length
        if (data.is_error == 0 && data.override_text == 'You have already submitted the request.' && !window.location.pathname.includes('/thanks/')) {
          // this.router.navigate
          setTimeout(() => {
            this.router.navigate(['/thanks', this.contractToken], { queryParams: { reload: 1 } });
          }, 20);
          return;
        }

        if (data.feature_list && data.feature_list.length) {
          this.mainService.featureList = data.feature_list;
        }
        if (data.split_request_data && data.split_request_data.length > 0) {
          if (Number(data.split_request_data?.[0]?.contract_id) === 0 && window.location.pathname.includes('/payment-details/')) {
            // tslint:disable-next-line:max-line-length
            this.proposal.choosePlanV2(this.contractToken, data.split_request_data[0]?.plans_array?.[0], 0, 1, 'check_email_code_apf');
            return;
          }
            const dummyValue = data && data.split_request_data && data.split_request_data[0]['doctor_id'];
            localStorage.setItem('split_req_id',dummyValue);
          if (data && data.split_request_data && data.split_request_data[0].is_ar_contract == 1) {
            localStorage.setItem('ar', data.split_request_data[0].is_ar_contract);
          } else {
            localStorage.removeItem('ar');
          }
          const getCountryId = data && data['doctor_country_currency_info'] && data['doctor_country_currency_info'].country && data['doctor_country_currency_info'].country['country_id'];
          this.planInfo = data.split_request_data[0];
          const getCountryId1 = data && data.split_request_data && data.split_request_data[0] && data.split_request_data[0].country_id;
          const countryIdValue = getCountryId1 ? getCountryId1 : getCountryId;
          if(countryIdValue) {
            this.proposal.getSupportData(countryIdValue);
          }
          // tslint:disable-next-line:max-line-length
          this.enrollmentFee = this.planInfo.plans_array && this.planInfo.plans_array[0] && JSON.stringify(this.planInfo.plans_array[0].enrollment_fee && this.planInfo.plans_array[0].enrollment_fee==0) ? JSON.stringify(this.planInfo.plans_array[0].enrollment_fee) : "30";
          this.enrollmentFee = JSON.parse(this.enrollmentFee);
          this.contract_service_record = this.planInfo && this.planInfo.contract_service_record;
          if (this.planInfo && this.planInfo.contract_service_record && typeof this.planInfo.contract_service_record == 'string') {
            this.contract_service_record = JSON.parse(this.planInfo.contract_service_record);
          }

          if (data.split_request_data[0].is_financed == 0 || data.split_request_data[0].is_req_expired == 0) {
            if (data.split_request_data[0].request_from == 1 && this.url != "pay-now") {
              this.router.navigate(['pay-now', this.contractToken]);
            } else if (data.split_request_data[0].request_from != 1 && this.url == "pay-now") {
              this.router.navigate(['plans', this.contractToken]);
            }
            this.proposal.sendData(data);
          }
          if (data.split_request_data[0].is_financed == 1) {
            if (data.split_request_data[0].request_from == 1) {
              this.router.navigate(['thanks', this.contractToken]);
            } else {  
              this.router.navigate(['personal-details', this.contractToken]);
            }
          }

          if (data.split_request_data[0].is_req_expired == 1) {
            this.router.navigate(["/invalid"]);
          }
          this.proposal.sendData(data);
        } else if (!Number(data.is_error)) {
          this.proposal.sendData(data);
        }
        
        // tslint:disable-next-line:max-line-length
        if (data.split_request_data && data.split_request_data[0] && data.split_request_data[0].contract_id != 0 && Number(data.split_request_data[0].is_deconsted) === 0 && data.split_request_data[0].patient_status == 2) {
          this.router.navigate(['/thanks', this.contractToken], { queryParams: { reload: 1 } })
        } else if (data.split_request_data && data.split_request_data[0].is_deleted == 1) {
          if (data.split_request_data && data.split_request_data && data.split_request_data[0].active_requests) {
            const active_requests = data.split_request_data[0].active_requests;
            if (active_requests.length == 0) {
              this.router.navigate(['/invalid'], { queryParams: { del: 1, token: this.contractToken } });
              // } else if (active_requests.length == 1) {
              //   this.router.navigate(['/plans/' + active_requests[0]]);
            } else {
              this.router.navigate(['/invalid'], { queryParams: { del: 1, token: this.contractToken } });
            }
          } else {
            this.router.navigate(['/invalid'], { queryParams: { del: 1, token: this.contractToken } });
          }
        } else if (Number(data.is_error)) {
          let active_requests = [];
          if (data.split_request_data && data.split_request_data[0] && data.split_request_data[0].active_requests) {
            active_requests = data.split_request_data[0].active_requests;
          }
          if (active_requests.length == 0) {
            this.router.navigate(['/invalid'], { queryParams: { token: this.contractToken } });
            // } else if (active_requests.length == 1) {
            //   this.router.navigate(['/plans/' + active_requests[0]]);
          } else {
            this.router.navigate(['/invalid'], { queryParams: { token: this.contractToken } });
          }
        }
        if (data.doctor_country_currency_info) {
          const country = data.doctor_country_currency_info['country'];
          this.mainService.currency_data.default_mobile_code = country['mobile_code'];
          this.mainService.currency_data.display_logo = data.doctor_country_currency_info['currency'][0]['display_logo'];
          this.mainService.currency_data.country_code = country['country_code'];
          this.mainService.currency_data.currency_code = data.doctor_country_currency_info['currency'][0]['currency_code'];
          this.mainService.showSSNFields = data.doctor_country_currency_info['SSN'];
          this.mainService.document_label = country['identity_label'];
          this.mainService.minDocumentIdLength = (country['identity_document_min_length']) || 8;
          this.mainService.maxDocumentIdLength = (country['identity_document_max_length']) || 18;
          console.log(this.mainService.maxDocumentIdLength, this.mainService.minDocumentIdLength);
          
          if (this.planInfo.practice_mobile) {
            // tslint:disable-next-line:max-line-length
            this.planInfo.practice_mobile = this.planInfo.practice_mobile.replace(this.mainService.countryWiseRegex[country['country_code']]['regex'], this.mainService.countryWiseRegex[country['country_code']]['group']);
            console.log(this.planInfo.practice_mobile);
          }
          if (this.planInfo.patient_mobile) {
            // tslint:disable-next-line:max-line-length
            this.planInfo.patient_mobile = this.planInfo.patient_mobile.replace(this.mainService.countryWiseRegex[country['country_code']]['regex'], this.mainService.countryWiseRegex[country['country_code']]['group']);
            console.log(this.planInfo.patient_mobile);
          }
          if (this.planInfo.doctor_mobile) {
            // tslint:disable-next-line:max-line-length
            this.planInfo.doctor_mobile = this.planInfo.doctor_mobile.replace(this.mainService.countryWiseRegex[country['country_code']]['regex'], this.mainService.countryWiseRegex[country['country_code']]['group']);
            console.log(this.planInfo.doctor_mobile);
          }
          if (this.planInfo.doctor_phone) {
            // tslint:disable-next-line:max-line-length
            this.planInfo.doctor_phone = this.planInfo.doctor_phone.replace(this.mainService.countryWiseRegex[country['country_code']]['regex'], this.mainService.countryWiseRegex[country['country_code']]['group']);
            console.log(this.planInfo.doctor_phone);
          }
          // if (!((this.mainService.strike_enrollment_fee + '').includes(this.mainService.currency_data.display_logo))) {
          //   this.mainService.strike_enrollment_fee = this.mainService.currency_data.display_logo + this.mainService.strike_enrollment_fee;
          // }
        }
        if (data.feeData) {
          this.mainService.strike_enrollment_fee = data.feeData.strike_enrollment_fee;
          this.mainService.strike_transaction_fee = data.feeData.strike_transaction_fee;
          this.mainService.strike_transaction__below_fee = data.feeData.strike_transaction_fee;
        }
        this.mainService.setLoader(false);
      });
  }

  checkIfArPp() {
    if (this.closeOnly && !this.api) {
      return;
    }

    const params = {
      token: this.contractToken
    };
    this.mainService.setLoader(true);
    this.proposal.api('post', 'check_if_ar_pp', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data.ar_pp == 1) {
          this.makePaymentPlan();
        } else {
          this.checkToken();
        }
      }, (error: any) => {
        this.mainService.setLoader(false);
      });
  }

  makePaymentPlan() {
    const params = {
      payment_link_token: this.contractToken,
      contract_type: 5 // check this should not fail
    };

    this.mainService.setLoader(true);
    this.proposal.api('post', 'add_split_plan', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data) {
          this.checkToken();
        } else {
          this.mainService.setLoader(false);
        }
      }, (error: any) => {
        this.mainService.setLoader(false);
      });
  }
  changeScreen() {
    this.triggerChangeScreen.emit();
  }
  goBack() {
    this.triggerChangeScreens.emit();
  }
  /* Open Modal Window */
  confirmCloseModel() {
    if (this.redirect_url && this.redirect_url.length) {
      window.location.href = this.redirect_url + '?manual_close=manual_close';
    } else {
      this.cancelModal.show();
      this.getReasonList();
      this.step = 1;
      this.reasonError = false;
      this.otherReason = '';
      this.reasonSent = false;
    }

  }

  /* Get reason List */
  // reasonList = [];
  getReasonList() {
    this.reasonSent = false;
    this.reasonCheckedList = [];
    const params = {
      proposal_token: this.contractToken
    };
    this.proposal.api('post', 'get_proposal_reason_list', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        data.reason.forEach(element => {
          element.is_checked = false;
          if (element.child) {
            element.childShow = false;
            element.child.forEach(ele => {
              ele.is_checked = false;
            });
          }
        });
        this.reasonList = data.reason;
        // console.log(this.reasonList);

      });
  }

  changeReason() {
    setTimeout(() => {
      this.reasonCheckedList = [];
      this.reasonList.forEach(element => {
        if (element.is_checked) {
          if (element.child) {
            element.childShow = true;
            element.child.forEach(ele => {
              if (ele.is_checked) {
                this.reasonCheckedList.push(ele.reason_id);
              }
            });
          }
          this.reasonCheckedList.push(element.reason_id);
          if (this.reasonCheckedList.length) {
            this.reasonSent = false;
          }
        } else {
          if (element.child) {
            element.childShow = false;
          }
        }
      });
    }, 150);
  }

  /* Send Feedback - Reason */
  // reasonCheckedList = [];
  // otherReason: string;
  // reasonError = false;
  // noChildSelected = true;
  sendFeedback() {
    this.reasonError = false;
    this.noChildSelected = true;
    if (this.reasonSent) {
      return false;
    }

    if (!this.reasonCheckedList.length) {
      this._toaster.message('Please select a reason.', 3);
      return false;
    }

    if (this.reasonCheckedList.indexOf(100) !== -1 && !this.otherReason) {
      this.reasonError = true;
      this._toaster.message('Please mention reason.', 3);
      return false;
    }

    this.reasonList.forEach(element => {
      if (element.is_checked && element.child) {
        element.child.forEach(ele => {
          const childCheckedLen = element.child.filter((item, index) => {
            return item.is_checked;
          });
          if (!childCheckedLen.length) {
            this._toaster.message('Please select a reason.', 3);
            this.noChildSelected = false;
            return false;
          }
        });
      }
    });
    if (!this.noChildSelected) {
      return false;
    }
    this.reasonSent = true;
    const params = {
      proposal_token: this.contractToken,
      cancel_type: 1,
      reason_id: this.reasonCheckedList.length ? this.reasonCheckedList : '',
      other_reason: this.reasonCheckedList.length ? this.otherReason.trim() : ''
    };
    this.mainService.setLoader(true);
    this.proposal.api('post', 'create_propsal_reason_user', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.cancelModal.hide();
          this.router.navigate(['/remind-later/' + this.contractToken], { queryParams: { reason: 'Not interested' } });
          this.mainService.setLoader(false);
        } else {
          this.mainService.setLoader(false);
          this._toaster.message(data.err, 3);
        }
      });
  }

  /* Send Feedback - Remind me later */
  remindLater() {
    if (this.reasonSent) {
      return false;
    }
    this.reasonSent = true;
    let params = {
      proposal_token: this.contractToken,
      cancel_type: 0
    };
    this.mainService.setLoader(true);
    this.proposal.api('post', 'create_propsal_reason_user', this.mainService.urlParams(params))
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.cancelModal.hide();
          this.router.navigate(['/remind-later/' + this.contractToken], { queryParams: { reason: 'Remind me later' } });
          this.mainService.setLoader(false);
        } else {
          this.mainService.setLoader(false);
          this._toaster.message(data.err, 3);
        }
      });
  }

  getNamelogo(name) {
    const useName = name.split(' ');
    if (useName[0] === 'undefined') {
      return '';
    }
    if (useName.length > 1) {
      return String(useName[0][0] + useName[1][0]);
    } else if (Number(useName.length) === 1) {
      return useName[0][0].toUpperCase();
    }
  }
 headerExpend() {
  this.headerExpendicon = !this.headerExpendicon;
 }
 topheaderData() {
  this.topHeaderexpend = !this.topHeaderexpend;
  this.mainService.topHeader.next(this.topHeaderexpend);
 }

}
